// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".footer[data-v-d384789e]{margin-top:60px;padding-top:60px;padding-bottom:48px;background:#292e3b}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
